import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ae783d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "milestones-grid" }
const _hoisted_2 = { class: "milestones-grid__levels" }
const _hoisted_3 = { class: "milestones-grid__grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "maximize",
  class: "milestones-grid__expand",
  src: "/img/icons/maximize--grey.svg"
}, null, -1))
const _hoisted_6 = { class: "milestones-grid__category-milestones" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_MilestoneTooltip = _resolveComponent("MilestoneTooltip")!
  const _component_MilestoneCell = _resolveComponent("MilestoneCell")!
  const _component_ElPopover = _resolveComponent("ElPopover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelsCount, (levelNumber) => {
        return (_openBlock(), _createElementBlock("div", {
          key: levelNumber,
          class: _normalizeClass([{
          'milestones-grid__level--active': levelNumber === _ctx.currentLevel,
        }, "milestones-grid__level"])
        }, _toDisplayString(levelNumber), 3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: category.name,
          class: "milestones-grid__category"
        }, [
          _createVNode(_component_ElTooltip, {
            content: category.name,
            placement: "top",
            "popper-class": "milestones-grid__tooltip el-tooltip__popper--small el-abaca-tooltip"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "milestones-grid__category-name",
                onClick: ($event: any) => (_ctx.$emit('show-carousel', category))
              }, [
                _createTextVNode(_toDisplayString(category.abbreviation) + " ", 1),
                _hoisted_5
              ], 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["content"]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.milestones, (milestone) => {
              return (_openBlock(), _createBlock(_component_ElPopover, {
                key: milestone.level,
                "hide-after": 0,
                placement: "top",
                "popper-class": "px-popover--light milestone-cell-popover",
                trigger: "click",
                width: "242px",
                onHide: _ctx.onTooltipHide,
                onShow: ($event: any) => (_ctx.onTooltipShow(milestone))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_MilestoneCell, {
                    class: _normalizeClass([{
                  'milestones-grid__milestone--blurred':
                    _ctx.isMilestoneBlurred(milestone),
                }, "milestones-grid__milestone"]),
                    color: category.color,
                    completed: milestone.completed,
                    critical: milestone.critical,
                    "evidence-provided": milestone.evidenceProvided,
                    future: milestone.future,
                    "in-progress": milestone.inProgress,
                    planned: milestone.planned
                  }, null, 8, ["class", "color", "completed", "critical", "evidence-provided", "future", "in-progress", "planned"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_MilestoneTooltip, {
                    "category-color": category.color,
                    "category-name": category.name,
                    "has-evidence": milestone.evidenceProvided,
                    "is-future-milestone": milestone.future,
                    "is-milestone-complete": milestone.completed,
                    "is-milestone-critical": milestone.critical,
                    "is-milestone-in-progress": milestone.inProgress,
                    "is-milestone-planned": milestone.planned,
                    "is-visitor": _ctx.isVisitor,
                    "level-number": milestone.level,
                    "milestone-description": milestone.description,
                    "target-date": milestone.targetDate,
                    onComplete: ($event: any) => (_ctx.onMilestoneCompleteClick(category.id, milestone.level)),
                    onPlan: ($event: any) => (_ctx.onMilestonePlanClick(category.id, milestone.level))
                  }, null, 8, ["category-color", "category-name", "has-evidence", "is-future-milestone", "is-milestone-complete", "is-milestone-critical", "is-milestone-in-progress", "is-milestone-planned", "is-visitor", "level-number", "milestone-description", "target-date", "onComplete", "onPlan"])
                ]),
                _: 2
              }, 1032, ["onHide", "onShow"]))
            }), 128))
          ])
        ]))
      }), 128)),
      _createElementVNode("div", {
        style: _normalizeStyle({
          transform: `translateY(${_ctx.currentLevelLinePosition}px)`,
        }),
        class: "milestones-grid__current-level-line"
      }, null, 4)
    ])
  ]))
}